<!--  -->
<template>
  <div class="DialogImage">
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="dialogVisible" width="600px">
      <div class="demo-image__preview">
        <el-image
          style="width: 420px; height: 296.5px"
          :src="url"
          :preview-src-list="srcList"
        >
        </el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      url: '',
      srcList: []
    };
  },
  props: {
    title: "",
  },
  components: {},

  computed: {},

  mounted() {},

  methods: {
      showDialog(url){
          this.url = url;
          this.srcList=[url];
          this.dialogVisible = true;
      }
  },
};
</script>
<style scoped lang="scss">
/deep/ .el-dialog {
  .el-dialog__header {
    padding: 15px 20px;
    text-align: left;
    background: #f5f5f5;
    .el-dialog__title {
      font-size: 14px;
    }
  }
  .el-dialog__body {
    padding: 50px 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DialogImage.vue